import getUserProfile from "app/api/requests/Users/getUserProfile";
import delUserProfile from "app/api/requests/Users/delUserProfile";
import getUserProfiles from "app/api/requests/Users/getUserProfiles";
import updateUserProfile from "app/api/requests/Users/updateUserProfile";

export default {
  getUserProfile,
  delUserProfile,
  getUserProfiles,
  updateUserProfile
};
